import SubmenuOption from "./SubmenuOption";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Submenu = function Submenu(_ref) {
  var title = _ref.title,
    options = _ref.options,
    selectedValue = _ref.selectedValue,
    onSelect = _ref.onSelect,
    isSpeed = _ref.isSpeed,
    isCCSubmenu = _ref.isCCSubmenu;
  return /*#__PURE__*/_jsxs("div", {
    className: "flex flex-col items-center text-center",
    children: [/*#__PURE__*/_jsx("span", {
      className: "font-button text-white mb-24",
      children: title
    }), isSpeed ? /*#__PURE__*/_jsxs("div", {
      className: "flex items-start",
      children: [/*#__PURE__*/_jsx("div", {
        className: "flex flex-col items-center mr-24",
        children: options.slice(0, options.length / 2).map(function (option, i) {
          return /*#__PURE__*/_jsx(SubmenuOption, {
            label: option.label,
            selected: option.value === selectedValue,
            onClick: function onClick() {
              onSelect(option);
            },
            isLast: i === options.length - 1
          }, "option-".concat(title, "-").concat(option.value));
        })
      }), /*#__PURE__*/_jsx("div", {
        className: "flex flex-col items-center",
        children: options.slice(options.length / 2).map(function (option, i) {
          return /*#__PURE__*/_jsx(SubmenuOption, {
            label: option.label,
            selected: option.value === selectedValue,
            onClick: function onClick() {
              onSelect(option);
            },
            isLast: i === options.length - 1
          }, "option-".concat(title, "-").concat(option.value));
        })
      })]
    }) : options.map(function (option, i) {
      return /*#__PURE__*/_jsx(SubmenuOption, {
        category: isCCSubmenu ? title : undefined,
        label: option.label,
        selected: option.value === selectedValue,
        onClick: function onClick() {
          onSelect(option);
        },
        isLast: i === options.length - 1
      }, "option-".concat(title, "-").concat(option.value));
    })]
  });
};
export default Submenu;